import { useEffect } from 'react';
import ChatBubble from 'components/ChatBubble';
import AdvocateAvailableToast from 'components/ChatBubble/AdvocateAvailableToast';
import { HandRaiserToastManager } from 'components/ChatBubble/HandRaiserToast';
import { useAppConfig } from 'hooks/appConfig';
import { getLocalStorageItem, updateLocalStorage } from 'utils/browserCache';
import { getVehicleId } from 'utils/chatContext/getInfoContext';
import { htmlId } from 'utils/html';
import { LOCAL_STORAGE_KEY } from 'constants/browserCache';
import { URL_PATHNAME } from 'constants/url';

/**
 * Container for Chat Bubble and Toasts
 * @returns
 */
const ChatArea = () => {
  const { appConfigState } = useAppConfig();

  // FIXME - below will be going away after https://github.com/propelai/chat-ui/pull/542
  const isPurchasePage = window.location.pathname.includes(URL_PATHNAME.PURCHASE);
  useEffect(() => {
    if (isPurchasePage) {
      const vehicleIdForPurchasePage = getVehicleId();
      // If current URL contains a vehicleId, cache it. Further re-entry into Purchase Page
      // may not contain it. See comment in getVehicleId() section C) for more info.
      if (vehicleIdForPurchasePage) {
        const existingCache = getLocalStorageItem(LOCAL_STORAGE_KEY.CVNA_CHAT_UI);
        updateLocalStorage(LOCAL_STORAGE_KEY.CVNA_CHAT_UI, {
          ...(existingCache && existingCache),
          vehicleIdPurchase: vehicleIdForPurchasePage,
        });
      }
    }
  }, [isPurchasePage]);

  if (appConfigState.isNativeMobileApp) {
    return <ChatBubble />;
  }

  /**
   *  Upon user landing on Purchase, SRP or STC page, React app will reload and funnel into <HandRaiserToastManager />
   *  Logic within then executes useUrlListener() -> pingForUrlChange(); for HR feature to work properly.
   */
  return (
    <div id={htmlId('chat-area')}>
      <AdvocateAvailableToast />
      <HandRaiserToastManager />
      <ChatBubble />
    </div>
  );
};

export default ChatArea;
